import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from 'reactstrap';

const CreateSubuser = ({ token, onCreate }) => {
  const [modal, setModal] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [isError, setIsError] = useState(false);

  const toggle = () => {
    if (!modal) setEmail('');
    setModal(!modal);
    setMessage(null);
    setIsError(false);
  };

  const handleEmailChange = (e) => setEmail(e.target.value);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const generateRandomEmail = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const randomStr = Array.from({ length: 7 }, () =>
      chars.charAt(Math.floor(Math.random() * chars.length))
    ).join('');
    return `user${randomStr}@blububl.com`;
  };

  const handleSubmit = async () => {
    const useFallback = !email.trim() || !isValidEmail(email.trim());
    const finalEmail = useFallback ? generateRandomEmail() : email.trim();

    const url = `${global.SERVIP}/user/create-subuser`;
    const body = {
      email: finalEmail,
      isAutoEmail: /^user[a-z0-9]{7,}@textlinksms\.com$/.test(finalEmail),
    }; const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });
      const result = await response.json();

      if (result.ok) {
        onCreate(result.subuser);
        setEmail('');
        setMessage(
          useFallback
            ? `Subuser created with random email: ${finalEmail}. Set a password manually to activate the account.`
            : 'The confirmation email has been sent to the user! You can also manually set their password by clicking change password.'
        );
        setIsError(false);
        setModal(false); // ✅ Close modal after success
      }
      else {
        setMessage(result.message || 'Server error');
        setIsError(true);
      }
    } catch (error) {
      setMessage('Network error');
      setIsError(true);
    }
  };

  return (
    <>
      <Button
        className="btn-dim"
        outline
        color="primary"
        style={{ width: '100%', marginBottom: 10, marginTop: 10 }}
        onClick={toggle}
      >
        Create new
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Create Subuser</ModalHeader>
        <ModalBody>
          {message && <Alert color={isError ? 'danger' : 'success'}>{message}</Alert>}
          <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
            <FormGroup>
              <p>
                You can enter an email for the new subuser, or leave it empty. If you don't enter a valid email,
                a random one will be generated automatically in the format:
                <br />
                <code>userXXXXXXX@blububl.com</code>
                <br />
                <strong>
                  You will need to manually set the password for that subuser to activate the account.
                </strong>
              </p>
              <Label for="email">Email (optional)</Label>
              <Input
                type="email"
                name="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Leave blank to auto-generate"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            OK
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CreateSubuser;
